import { defineStore } from 'pinia'

const STORE_NAME = 'helperModal';

export const useHelperState = defineStore(STORE_NAME, {
    state: () => ({
        showHelp: false,
        text: ''
    }),
    actions: {
        setText(message: string) {
            this.$state.text = message;
        },
        show() {
            this.$state.showHelp = true;
        },
        hide() {
            this.$state.showHelp = false;
        },
        _reset() {
            this.$reset();
        }
    }
})
